import React, { useState, useEffect, useRef } from 'react';
import * as s from './styled-select';

const Select = ({ list }) => {
  const [open, setOpen] = useState(false);
  const [filterText, setFilterText] = useState('');
  const containerRef = useRef();

  useEffect(() => {
    document.addEventListener('click', handleClick);
  }, []);

  const handleClick = (e) => {
    if (containerRef.current && !containerRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  return (
    <s.Container
      ref={containerRef}
      onClick={(e) => {
        e.preventDefault();
        setOpen(!open);
      }}
      onKeyPress={() => null}
    >
      <label>Trocar</label>
      <s.ArrowDown />
      {open && (
        <s.ListWrapper>
          <s.InputFilter
            placeholder="Pesquise"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />
          {list.map((item) => (
            <option
              key={item}
              onClick={(e) => {
                e.preventDefault();
                // setOpen(false);
              }}
              onKeyPress={() => null}
            >
              {item}
            </option>
          ))}
        </s.ListWrapper>
      )}
    </s.Container>
  );
};

export default Select;
